import styled from 'styled-components'
import FlagIcon from 'components/Common/FlagIcon'
import ViewPdf from 'components/Pages/Wine/View/Common/ViewPdf'
import breakpoints from 'utils/consts/breakpoints'

const tabletMediaQuery = `(max-width: ${breakpoints.size.lg}px) and (min-width: 700px)`

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 1;

  @media screen and ${tabletMediaQuery} {
    position: absolute;
    top: 0;
    width: 100%;
  }
`

const Top = ({ product }) => {
  return (
    <Wrapper>
      <FlagIcon codeISO={product?.wine?.country?.codeISO} size={36} />
      <ViewPdf productId={product?.id} currentLngProductData={product} />
    </Wrapper>
  )
}

export default Top
